import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';


const BusinessTypeInput: InputWithSource = ({ input }) => {
    const contractActions = useContractActions();

    return (
        <GenericSelect
            label={input.name}
            input={input}
            message={ValidationMessages.requiredInput(input.name)}
            allowClear={false}
            onChange={() => contractActions.dispatch(Actions.ChangeBusinessType)}
        />
    );
};

BusinessTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(BusinessTypeInput);
